export default __webpack_public_path__ + "static/media/0x9a05d1ff699ea187dc8523e333ed63503f0d82db.0570123b.jpeg";